import request from '@/service/request';

export const getFastQuotation = ({ quotationId }: { quotationId: string }) => {
  return request(
    `/v1/agency-platform-vn-v2/agency/quotes/${quotationId}?id_type=ext_id`,
  );
};

export const getApplictionConfig = ({
  productType,
  productKey,
  planKey,
}: {
  productType: string;
  productKey: string;
  planKey: string;
}) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/application_config`,
  );
};

export const submit = ({
  productType,
  productKey,
  planKey,
  data,
}: {
  productType: string;
  productKey: string;
  planKey: string;
  data: any;
}) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/application`,
    {
      method: 'POST',
      data,
    },
  );
};
